import { createStyles, Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { elevatedSurfaceBoxShadow, transition } from '../../../../shared/style-settings'

const cardRadius = 18

export const useMainPageHowItWorksCardStyles = makeStyles((theme: Theme) =>
  createStyles({
    card: {
      borderRadius: cardRadius,
      overflow: 'hidden',
      boxShadow: elevatedSurfaceBoxShadow,
      backgroundColor: theme.palette.common.white,
      transition,
      '&:focus-within': {
        outline: `3px solid ${theme.palette.primary.main}`,
        outlineOffset: 3,
      },
      '&:hover': {
        transform: 'translateY(-4px)',
        boxShadow:
          theme.palette.type === 'light'
            ? '0 12px 32px rgba(30, 50, 250, 0.12)'
            : elevatedSurfaceBoxShadow,
        '& $jumpCaret': {
          color: theme.palette.primary.main,
          borderColor: 'rgba(30, 50, 250, 0.22)',
        },
      },
    },
    cardLink: {
      textDecoration: 'none',
      color: 'inherit',
      display: 'block',
      height: '100%',
    },
    cardTop: {
      backgroundColor: theme.palette.common.white,
      padding: theme.spacing(2.75, 2.75, 2),
      paddingRight: theme.spacing(5.5),
      position: 'relative',
      minHeight: theme.spacing(16),
      [theme.breakpoints.down('sm')]: {
        minHeight: theme.spacing(14),
      },
    },
    stepLabel: {
      display: 'block',
      fontSize: '0.75rem',
      fontWeight: 600,
      color: theme.palette.text.primary,
      textTransform: 'uppercase',
      letterSpacing: '0.06em',
      marginBottom: theme.spacing(1.25),
    },
    pill: {
      display: 'inline-block',
      padding: theme.spacing(0.75, 2),
      borderRadius: 999,
      fontSize: 'clamp(0.8125rem, 1.1vw, 0.95rem)',
      fontWeight: 600,
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
      lineHeight: 1.35,
      maxWidth: '100%',
    },
    jumpCaret: {
      position: 'absolute',
      top: theme.spacing(1.75),
      right: theme.spacing(1.75),
      width: theme.spacing(4.75),
      height: theme.spacing(4.75),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: theme.palette.common.white,
      border: `1px solid rgba(30, 50, 250, 0.12)`,
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
      color: theme.palette.text.primary,
      borderRadius: '50%',
      pointerEvents: 'none',
      transition,
      '& svg': {
        fontSize: '1.1rem',
      },
    },
    imageShell: {
      position: 'relative',
      height: 148,
      width: '100%',
      overflow: 'hidden',
      [theme.breakpoints.down('sm')]: {
        height: 164,
      },
    },
    waveSvg: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      height: 28,
      width: '100%',
      display: 'block',
      pointerEvents: 'none',
      zIndex: 1,
    },
    cardImage: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block',
    },
  })
)
